module.exports = __webpack_public_path__ + "img/Hules_Colores.cbe48fba.png";